import * as React from "react";
import type { HierarchyContext, HierarchyNode } from "./types";

// biome-ignore lint/suspicious/noExplicitAny: Context needs to accept any node type for type safety with generics
export const HierarchyContextInstance = React.createContext<HierarchyContext<any> | null>(null);

export function useHierarchyContext<T extends HierarchyNode = HierarchyNode>() {
  const context = React.useContext(HierarchyContextInstance);
  if (!context) {
    throw new Error("Hierarchy components must be used within HierarchyExplorer");
  }
  return context as HierarchyContext<T>;
}
